import React, { useEffect, useState } from "react";
import { AcaTable, AcaTableHeader, AcaTableRow, AcaTableCell } from "./acaTable";
import { getConnectionInfo, ConnectionContext, displayErrorMessage, displayLoader } from "../utils";
import { TeamLogo } from "./teamLogo";


const DataTable = (props) => {
    const { 
        classes = '',
        data = false,
        fields = [],
        extraClasses = '',
        highlight = null,
        extraData = null,
        ...restProps 
    } = props;

    // Error and load handling
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);

    // Connection Information
    const [connectionInfo, setConnectionInfo] = useState(null);


    /**
     * Get our connection info
     */
    useEffect(() => {

        // Get our connection info
        getConnectionInfo().then(
            (result) => {
                setConnectionInfo(result.data);
            }
        ).catch(
            (error) => {
                setError(error);
            }
        );

      }, []);


    /**
     * Check if we have data
     */
    useEffect(() => {
        if ( data ) {
            setIsLoaded(true);
        } else {
            setIsLoaded(false);
        }
    }, [data]);

    /**
     * Get club URLs if needed
     */
    const getClubURL = (id) => {
        if ( !extraData ) return '';
        const club = extraData.find((row) => row.uid == id);
        return club ? club.url : '';
    }


    // Bail if we don't have data yet
    if (!isLoaded ) {
        return displayLoader('acaLoader--main');
    }

    // Display an error message if there's a problem
    if ( error ) {
        console.log(error);
        return displayErrorMessage();
    }

    let classList = "dataTable " + classes;

    return (
        <ConnectionContext.Provider value={connectionInfo}>
            <AcaTable classes={classList}>
                <AcaTableHeader>
                    { fields ? (
                        fields.map((field, i) => (
                            <AcaTableCell 
                                key={i} 
                                head={true} 
                                field={"key" in field ? field.key : false} 
                                center={"center" in field ? field.center : false} 
                                size={"size" in field ? field.size : 'regular'}
                                border={"border" in field ? true : false}
                                grey={"grey" in field ? true : false}
                            >
                                {"label" in field ? field.label : ''}
                            </AcaTableCell>
                        ))
                    ) : '' }
                </AcaTableHeader>
                <tbody>
                    { data ? (
                        data.map((row, i) => (
                            <AcaTableRow key={i}>
                                { fields ? (
                                    fields.map((field, n) => (
                                        <AcaTableCell 
                                            key={n}
                                            field={"key" in field ? field.key : false} 
                                            center={"center" in field ? field.center : false} 
                                            border={"border" in field ? true : false}
                                            highlight={ highlight && highlight == row.clubId ? true : false }
                                        >
                                            {"key" in field ? (
                                                <>
                                                { /** Handle club cells */ }
                                                { field.key == 'club' ? (
                                                    <a href={ getClubURL(row.clubId) }>
                                                        <TeamLogo teamId={row.clubId} />
                                                        { field.key in row ? row[field.key] : '' }
                                                    </a>
                                                ) : 
                                                    field.key in row ? row[field.key] : ''
                                                }
                                                </>
                                            )
                                            : ''}
                                        </AcaTableCell>
                                    ))
                                ) : '' }
                            </AcaTableRow>
                        ))
                    ) : '' }
                </tbody>
            </AcaTable>
        </ConnectionContext.Provider>
    );
}

export { DataTable };

